export default __webpack_public_path__ + "static/about-header-a109966319dcf1e332d66a8a34f9121e.png";